import FetchApi from "./api";
import config from "../config";

const serviceAvatar = {
  getAvatars: () =>
    FetchApi(`${config.urls.apiBaseUrl}api/Character/GetCharacters`, "GET"),
  getAvatar: (avatarID) =>
    FetchApi(
      `${config.urls.apiBaseUrl}api/Character/GetCharacterById/${avatarID}`,
      "GET"
    ),
  createAvatar: (payload) =>
    FetchApi(
      `${config.urls.apiBaseUrl}api/Character/CreateCharacter`,
      "POST",
      payload
    ),
  updateAvatar: (avatarID, payload) =>
    FetchApi(
      `${config.urls.apiBaseUrl}api/Character/UpdateCharacter/${avatarID}`,
      "PUT",
      payload
    ),
  swapAvatar: (id) =>
    FetchApi(
      `${config.urls.apiBaseUrl}api/Character/SwapCharacter/${id}`,
      "PUT"
    ),
};

export default serviceAvatar;